import { ASC_SORT_ORDER, DESC_SORT_ORDER } from '../constants/sortOrders'

const changeSortOrder = (currentSort) => {
    return currentSort === ASC_SORT_ORDER ? DESC_SORT_ORDER : ASC_SORT_ORDER
}

export default changeSortOrder
